import React from 'react';

function Input(props) {
    const classes = props.classes || 'w-input-sm';
    const type = props.type || 'text';
    const placeholder = props.placeholder || 'default';
    const handleChange = props.handleChange || null;
    return (
        <>
            <input onChange={event => handleChange(event)} type={type} placeholder={placeholder} className={classes} />
        </>
    );
}

export default Input;